import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FButton } from "ferrum-design-system";
import { useWalletConnector, useKeplrWalletConnector } from "foundry";
import { SwitchNetworkToAnotherModal } from "../../components/switchNetworkToAnotherModal";
import { addClassToBodyTag } from "../../../../utils/helperFunctions";
import { SwapAndWithDrawDialog } from "../../components/swap/SwapAndWithDrawDialog";
import { RootState } from "../../../../redux/rootReducer";
import * as networkActions from "../../../../redux/slices/network";
import * as swapActions from "../../../../redux/slices/swap";
// import * as SwapCruds from "../../../../_apis/SwapCrud";
import * as contractAllocationActions from "../../../../redux/slices/contract";
import { useHistory } from "react-router";
import toast from "react-hot-toast";
import Web3 from "web3";
import Big from "big.js";
import { ConnectButton } from "../../components/WalletConnectorButton";
import { useFoundrySendTransaction } from "foundry";

export const SwapPageActionButtons = ({
  amount,
  toInfo,
  fromInfo,
  showAmountWarning,
  maxBalance,
  isAnyWalletConnected,
  toNetworkTokenList,
  fromNetworkTokenList,
  setShowAmountWarning,
  setTokenSelectorDialogFor,
  setShowTokenSelectorDialog,
  setNetworkProgressBarDisable,
  destinationAddress,
  quoteLoading,
}: any) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { web3Sdk, walletAddress, currentNetworkChainId, setRPCUrl } =
    useWalletConnector();
  const [resetAllStatesOfDialog, setResetAllStatesOfDialog] = useState(false);
  const [showSwitchNetworkDlg, setShowSwitchNetworkDlg] = useState(false);
  const [showApprovedDialog, setShowApprovedDialog] = useState(false);
  const queryParams = new URLSearchParams(window.location.search);
  const slippage = queryParams.get("slippage") || "2";
  const demoMode = Boolean(queryParams.get("demo"));
  const {
    isPending,
    isConfirmed,
    isConfirming,
    hash,
    sendWeb3Transaction,
    reciept,
    error,
    isError,
    receiptError,
    status,
  } = useFoundrySendTransaction();

  const {
    selectedNetwork,
    isApproving,
    isApproved,
    approvalErrorMessage,
    isSwapping,
    allocation,
    isTokenQuoteLoading,
    approvalTransactionHash,
    swapAndWithdrawTxStatus,
    showSwapAndWithdrawDialog,
    swapTransactionHash,
    withdrawTransactionHash,
    tokenQuoteError,
    swapGasFee,
    isSwapGasFeeLoading,
    isSwappingScreenBlocked,
    swapAndWithdrawErrorMessage,
    sourceTokenCategorizedInfo,
    destinationTokenCategorizedInfo,
    fakeDestinationTokenCategorizedInfo,
  } = useSelector((state: RootState) => ({
    ...state.swap,
    ...state.contract,
    ...state.networks,
  }));

  console.log({
    isPending,
    isConfirmed,
    isConfirming,
    hash,
    reciept,
    error,
    isError,
    receiptError,
    status,
  });

  useEffect(() => {
    setShowApprovedDialog(false);
    dispatch(swapActions.closeSwapAndWithdrawDialog());
  }, [resetAllStatesOfDialog]);

  useEffect(() => {
    if (isError) {
      dispatch(
        swapActions.catchSwapAndWithdrawError((error as any)?.shortMessage)
      );
    }
  }, [error, isError]);

  useEffect(() => {
    if (hash && isSwapping) {
      dispatch(
        swapActions.swapAndWithdraw(
          hash,
          fromInfo,
          toInfo,
          amount,
          swapGasFee,
          slippage,
          sourceTokenCategorizedInfo,
          destinationTokenCategorizedInfo,
          fakeDestinationTokenCategorizedInfo
        )
      );
    } else if (hash && isApproving) {
      (
        dispatch(
          contractAllocationActions.getStandardContractAllocation(
            fromInfo.token.address,
            walletAddress,
            fromInfo.network.multiSwapFiberRouterSmartContractAddress,
            new Web3(fromInfo?.network?.rpcUrl) || web3Sdk,
            amount
          )
        ) as any
      ).then((isApproved: boolean) => {
        dispatch(
          swapActions.getTokenCategorizedInformation(
            walletAddress,
            fromInfo?.token?.address,
            fromInfo?.network?.chainId,
            amount,
            destinationAddress,
            toInfo?.token?.address,
            toInfo?.network?.chainId,
            slippage,
            isApproved
          )
        );
      });
    }
  }, [hash]);

  useEffect(() => {
    if (
      walletAddress &&
      fromInfo &&
      fromInfo?.network &&
      fromInfo?.token &&
      !fromInfo?.network?.isNonEVM &&
      !fromInfo?.token?.isNative &&
      Number(amount) > 0
    ) {
      dispatch(
        contractAllocationActions.getStandardContractAllocation(
          fromInfo.token.address,
          walletAddress,
          fromInfo.network.multiSwapFiberRouterSmartContractAddress,
          new Web3(fromInfo?.network?.rpcUrl) || web3Sdk,
          amount
        )
      );
    }
  }, [fromInfo?.network, fromInfo?.token, amount]);

  const handleSwapAction = () => {
    if (
      sourceTokenCategorizedInfo &&
      destinationTokenCategorizedInfo &&
      swapGasFee
    ) {
      dispatch(
        swapActions.performSwap(
          walletAddress,
          fromInfo,
          toInfo,
          amount,
          destinationAddress,
          slippage,
          sourceTokenCategorizedInfo,
          destinationTokenCategorizedInfo,
          fakeDestinationTokenCategorizedInfo,
          swapGasFee,
          sendWeb3Transaction
        )
      );
    }
  };

  const handleApproveAndConfirmSwapAction = async () => {
    dispatch(contractAllocationActions.resetApproveTxAndError());
    dispatch(swapActions.makeAnotherSwap());
    dispatch(swapActions.resetSourceAndDestinationTokenCategorizedInfo());
    if (
      (fromInfo?.network?.isNonEVM || toInfo?.network?.isNonEVM) &&
      !destinationAddress
    ) {
      toast.error("Please Enter Send To Address");
      return;
    } else if (Number(amount) <= 0) {
      toast.error("Please Enter Amount");
      return;
    }
    if (Number(amount) > 0 && new Big(amount).gt(new Big(maxBalance))) {
      toast.error(
        `You don't have that much ${fromInfo?.token?.symbol} tokens to swap`
      );
      return;
    }
    if (fromInfo?.network?.chainId === toInfo?.network?.chainId) {
      toast.error("Same network swaps are currently not available");
      return;
    } else if (
      destinationAddress &&
      !Web3?.utils.isAddress(destinationAddress)
    ) {
      toast.error("Please Enter Valid Address");
      return;
    } else if (
      !fromInfo?.network?.isNonEVM &&
      currentNetworkChainId === Number(fromInfo?.network?.chainId)
    ) {
      // dispatch(contractAllocationActions.resetContractAllocationState());
      setShowApprovedDialog(true);
      setNetworkProgressBarDisable(true);
      if (
        !isApproved &&
        allocation &&
        Number(allocation) < Number(amount) &&
        !fromInfo?.token?.isNative
      ) {
        console.log("Approve Action");
        (
          dispatch(
            contractAllocationActions.approveContractAllocation(
              fromInfo?.network.chainId,
              fromInfo?.token.address,
              walletAddress,
              fromInfo?.network.multiSwapFiberRouterSmartContractAddress,
              new Web3(fromInfo?.network?.rpcUrl) || web3Sdk,
              amount,
              sendWeb3Transaction
            )
          ) as any
        ).then(() => {
          (
            dispatch(
              contractAllocationActions.getStandardContractAllocation(
                fromInfo.token.address,
                walletAddress,
                fromInfo.network.multiSwapFiberRouterSmartContractAddress,
                new Web3(fromInfo?.network?.rpcUrl) || web3Sdk,
                amount
              )
            ) as any
          ).then((isApproved: boolean) => {
            dispatch(
              swapActions.getTokenCategorizedInformation(
                walletAddress,
                fromInfo?.token?.address,
                fromInfo?.network?.chainId,
                amount,
                destinationAddress,
                toInfo?.token?.address,
                toInfo?.network?.chainId,
                slippage,
                isApproved
              )
            );
          });
        });
      } else if (Number(amount)) {
        console.log("Swap Action");
        dispatch(
          swapActions.getTokenCategorizedInformation(
            walletAddress,
            fromInfo?.token?.address,
            fromInfo?.network?.chainId,
            amount,
            destinationAddress,
            toInfo?.token?.address,
            toInfo?.network?.chainId,
            slippage,
            fromInfo?.token?.isNative ? fromInfo?.token?.isNative : isApproved
          )
        );
      }
    }
  };

  const handleSelectorFor = () => {
    if (!fromInfo?.network) {
      setTokenSelectorDialogFor(`FROM_NETWORK`);
    } else if (
      fromInfo?.network &&
      !fromInfo?.token &&
      fromNetworkTokenList.length === 0
    ) {
      setTokenSelectorDialogFor(`FROM_NETWORK`);
    } else if (!fromInfo?.token) {
      setTokenSelectorDialogFor(`FROM_TOKEN`);
    } else if (!toInfo?.network) {
      setTokenSelectorDialogFor(`TO_NETWORK`);
    } else if (
      toInfo?.network &&
      !toInfo?.token &&
      toNetworkTokenList.length === 0
    ) {
      setTokenSelectorDialogFor(`TO_NETWORK`);
    } else if (!toInfo?.token) {
      setTokenSelectorDialogFor(`TO_TOKEN`);
    }
  };

  const switchNetwork = async (
    networkPayload: any,
    fromInfo: any,
    toInfo: any
  ) => {
    try {
      let ethereum = (window as any).ethereum;
      if (ethereum) {
        const hexChainId = Number(networkPayload.networkId).toString(16);
        await ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: `0x${hexChainId}` }],
        });
        setRPCUrl(networkPayload?.rpcUrl);
        dispatch(
          networkActions.setSelectedNetwork({ selectedNetwork: networkPayload })
        );
        dispatch(swapActions.setFromInfo(fromInfo));
        dispatch(swapActions.setToInfo(toInfo));
        const queryParams = new URLSearchParams(window.location.search);
        queryParams.set("amount", "");
        history.push({
          pathname: "/swap",
          search: queryParams.toString(),
        });
      }
    } catch (error: any) {
      toast.error(error?.message);
      console.log(error);
      dispatch(swapActions.setFromInfo(fromInfo));
      dispatch(swapActions.setToInfo(toInfo));
    }
  };
  // console.log({ quoteLoading, isSwapping });

  const showConnectButton = !isAnyWalletConnected;

  const showSelectTokenButton =
    !fromInfo?.network ||
    !fromInfo?.token ||
    !toInfo?.network ||
    !toInfo?.token;

  const showSwitchNetworkButton =
    currentNetworkChainId &&
    fromInfo?.network?.chainId &&
    String(currentNetworkChainId) !== fromInfo?.network?.chainId;

  const showEnterAmountButton =
    fromInfo?.network &&
    fromInfo?.token &&
    toInfo?.network &&
    toInfo?.token &&
    Number(amount) === 0;

  const showSwapButton =
    isAnyWalletConnected &&
    fromInfo?.network &&
    fromInfo?.token &&
    toInfo?.network &&
    toInfo?.token;

  return (
    <>
      <>
        {showSelectTokenButton ? (
          <FButton
            variant="ms-primary"
            className="swap-page-btn select-token-btn"
            title={"SELECT TOKEN"}
            disabled={demoMode}
            onClick={() => {
              handleSelectorFor();
              addClassToBodyTag(true);
              setShowTokenSelectorDialog(true);
            }}
          />
        ) : fromInfo?.network?.isNonEVM &&
          selectedNetwork?.isNonEVM !== fromInfo?.network?.isNonEVM ? (
          <FButton
            variant="ms-primary"
            className="swap-page-btn switch-network-btn"
            title={"SWITCH NETWORK"}
            disabled={demoMode}
            onClick={() => setShowSwitchNetworkDlg(true)}
          />
        ) : toInfo?.network?.chainId && showSwitchNetworkButton ? (
          <FButton
            variant="ms-primary"
            className="swap-page-btn switch-network-btn"
            title={"SWITCH NETWORK"}
            disabled={demoMode}
            onClick={() => switchNetwork(fromInfo?.network, fromInfo, toInfo)}
          />
        ) : showEnterAmountButton ? (
          <FButton
            variant="ms-primary"
            className="swap-page-btn enter-amount-btn"
            title={"ENTER THE AMOUNT"}
            // disabled={demoMode}
            onClick={() => setShowAmountWarning(true)}
          />
        ) : showSwapButton ? (
          <FButton
            disabled={
              quoteLoading ||
              isSwapGasFeeLoading ||
              isTokenQuoteLoading ||
              showSwapAndWithdrawDialog ||
              demoMode
            }
            variant={"ms-primary"}
            title={
              quoteLoading || isTokenQuoteLoading
                ? "FETCHING QUOTE"
                : isSwapGasFeeLoading
                ? "FETCHING GAS FEE"
                : (showSwapAndWithdrawDialog &&
                    swapAndWithdrawTxStatus !== "swapWithdrawCompleted") ||
                  isSwappingScreenBlocked
                ? "SWAPPING"
                : "SWAP"
            }
            className={`swap-page-btn swap-btn ${
              quoteLoading ||
              isTokenQuoteLoading ||
              showSwapAndWithdrawDialog ||
              isSwappingScreenBlocked ||
              isSwapGasFeeLoading
                ? "loading-btn"
                : ""
            }`}
            onClick={() => handleApproveAndConfirmSwapAction()}
          />
        ) : showConnectButton ? (
          <div className="ms-btn-primary swap-page-btn swap-btn">
            <ConnectButton
              title="CONNECT TO START"
              className="  
            f-btn-ms-primary f-btn-button swap-page-btn swap-btn"
            />
          </div>
        ) : null}
        {(showApprovedDialog || showSwapAndWithdrawDialog) &&
        !isSwappingScreenBlocked ? (
          <SwapAndWithDrawDialog
            slippage={slippage}
            tokenData={fromInfo?.token}
            sourceTokenCategorizedInfo={sourceTokenCategorizedInfo}
            destinationTokenCategorizedInfo={destinationTokenCategorizedInfo}
            isTokenQuoteLoading={isTokenQuoteLoading}
            isSwapGasFeeLoading={isSwapGasFeeLoading}
            swapSourceAndDestinationFeeInfo={swapGasFee}
            showApprovedDialog={showApprovedDialog || showSwapAndWithdrawDialog}
            setShowApprovedDialog={setShowApprovedDialog}
            isSwapping={isSwapping}
            isApproving={isApproving}
            swapTransactionHash={swapTransactionHash}
            approvalTransactionHash={approvalTransactionHash}
            withdrawTransactionHash={withdrawTransactionHash}
            setResetAllStatesOfDialog={setResetAllStatesOfDialog}
            resetAllStatesOfDialog={resetAllStatesOfDialog}
            fromInfo={fromInfo}
            toInfo={toInfo}
            handleSwapAction={handleSwapAction}
            status={swapAndWithdrawTxStatus}
            error={
              swapAndWithdrawErrorMessage ||
              approvalErrorMessage ||
              tokenQuoteError
            }
          />
        ) : null}
      </>
    </>
  );
};
